import type { AddableFolder } from './api/uploads.ts';
import type { MergedFolder } from './documentsMerge.ts';

/**
 * What the Documents "+" offers (145): the catalogue folders the server says this client lacks and the reader may
 * add, less any the top level already shows. Real Estate shown from Clio's files alone is already there (its first
 * upload makes the Procura folder), so it is not offered twice. Names compared as the merged view compares sections:
 * capitals and spacing ignored, nothing else. The server's answer is the rule; this only never offers what is shown.
 */
export function offeredTopFolders(addable: AddableFolder[], tops: MergedFolder[]): AddableFolder[] {
  const key = (name: string) => name.toLowerCase().replace(/\s+/g, '');
  const shown = new Set(tops.map((t) => key(t.name)));
  return addable.filter((a) => !shown.has(key(a.name)));
}
